import { Typography } from 'antd';
import { NODE_KIND_META, type NodeKind } from '@/theme/tokens';
import { resolveGlyph } from './glyphs';

const { Text } = Typography;

const KEY_KINDS: NodeKind[] = [
  'capability',
  'decision',
  'humanTask',
  'subFlow',
  'multiSourceScoring',
  'terminal',
  'llmTask',
];

function Line({ children }: { children: React.ReactNode }) {
  return <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '2px 0' }}>{children}</div>;
}

/** Reads the canvas visual language: three edge kinds + node kinds. Colour is never the sole signal. */
export function Legend() {
  return (
    <div style={{ width: 300, fontSize: 12 }}>
      <Text strong style={{ fontSize: 11, letterSpacing: '0.05em' }}>
        EDGE KINDS
      </Text>
      <div style={{ margin: '6px 0 12px' }}>
        <Line>
          <svg width={34} height={10} aria-hidden>
            <line x1="0" y1="5" x2="34" y2="5" stroke="var(--ol-text-tertiary)" strokeWidth="2" />
          </svg>
          <span>Sequence — B runs after A completes</span>
        </Line>
        <Line>
          <svg width={34} height={10} aria-hidden>
            <line x1="0" y1="5" x2="34" y2="5" stroke="var(--ol-negative)" strokeWidth="2" />
          </svg>
          <span>Status — routes on a completion status (pill)</span>
        </Line>
        <Line>
          <svg width={34} height={10} aria-hidden>
            <line x1="0" y1="5" x2="34" y2="5" stroke="var(--ol-info)" strokeWidth="1.5" strokeDasharray="5 4" />
          </svg>
          <span>Data — binds output→input, never gates</span>
        </Line>
      </div>

      <Text strong style={{ fontSize: 11, letterSpacing: '0.05em' }}>
        VALIDATION
      </Text>
      <div style={{ margin: '6px 0 12px' }}>
        <Line>
          <span className="ol-edge-diagchip ol-edge-diagchip--error" aria-hidden>
            ●
          </span>
          <span>Error — the compiler refuses this; publish is gated</span>
        </Line>
        <Line>
          <span className="ol-edge-diagchip ol-edge-diagchip--warning" aria-hidden>
            ▲
          </span>
          <span>Warning — flagged, never gates a publish</span>
        </Line>
        <Line>
          <span className="ol-edge-diagchip ol-edge-diagchip--error ol-edge-diagchip--stale" aria-hidden>
            ●
          </span>
          <span>Hollow = from the last validation; the flow changed since</span>
        </Line>
      </div>

      <Text strong style={{ fontSize: 11, letterSpacing: '0.05em' }}>
        NODE KINDS
      </Text>
      <div style={{ marginTop: 6, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px 10px' }}>
        {KEY_KINDS.map((k) => {
          const m = NODE_KIND_META[k];
          return (
            <Line key={k}>
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 2,
                  background: m.accent,
                  flex: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                aria-hidden
              />
              <span style={{ color: m.accent, display: 'inline-flex', alignItems: 'center' }}>
                {resolveGlyph(m.glyph)}
              </span>
              <span style={{ fontSize: 11.5 }}>{m.label}</span>
            </Line>
          );
        })}
      </div>
    </div>
  );
}
